import { Text } from '../cdl/Text/Text';
import { translate } from '../common/helpers/translate.helper';
import { useDocumentTitle } from '../common/hooks/useDocumentTitle';
import { useRole } from '../common/hooks/useRole';
import { Page } from '../common/Page/Page';
import { Box } from '../common/ui/Box';

import { AdminSearchResultOfferTable } from './components/AdminSearchResultOfferTable';
import { AdminSearchResultOrderTable } from './components/AdminSearchResultOrderTable';
import { CustomerSearchResult } from './components/CustomerSearchResult';
import { SupplierSearchResult } from './components/SupplierSearchResult';

export const SearchResultPage = () => {
    const role = useRole();

    useDocumentTitle(translate('searchResult.title'));

    if (role.isCustomer()) {
        return (
            <Page>
                <CustomerSearchResult />
            </Page>
        );
    }

    if (role.isSupplier()) {
        return (
            <Page>
                <SupplierSearchResult />
            </Page>
        );
    }

    if (role.isSuperAdmin()) {
        return (
            <Page>
                <Box display="flex" flexDirection="column" rowGap={40} marginBottom={24}>
                    <Text as="h1" variant="headline" marginBottom={24}>
                        {translate('searchResult.title')}
                    </Text>
                    <AdminSearchResultOrderTable />
                    <AdminSearchResultOfferTable />
                </Box>
            </Page>
        );
    }
};
